<template>
  <div class="notFound">
    <h1>Sorry, page is not found</h1>
    <p>Please, try another one</p>
    <v-btn color="primary" outlined @click="goToPrevPage">Prev page</v-btn>
    <v-btn color="primary" class="ml-4" depressed @click="goToSearch">Home</v-btn>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goToSearch() {
      this.$router.push({ name: 'MemberSearch', path: '/' });
    },
    goToPrevPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.notFound {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}
</style>
